import { NgModule } from "@angular/core";
import { LayoutComponent } from "./layout/layout.component";
import { HeaderNavSharedModule } from "./header-nav/header-nav_shared.module";
import { DefaultSharedModule } from "../pages/default/default_shared.module";
import { AsideNavSharedModule } from "./aside-nav/aside-nav_shared.module";
import { FooterComponent } from "./footer/footer.component";
import { TaskComponent } from "../../../app/task/task.component";
import { QuickSidebarComponent } from "./quick-sidebar/quick-sidebar.component";
import { ScrollTopComponent } from "./scroll-top/scroll-top.component";
import { TooltipsComponent } from "./tooltips/tooltips.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HrefPreventDefaultDirective } from "../../_directives/href-prevent-default.directive";
import { UnwrapTagDirective } from "../../_directives/unwrap-tag.directive";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../../../app/freightconfirmation/app.sharemodule";
import { CommonService } from "../../../app/_services/common.service";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../home/translateConfig.service";
// import { TableComponent } from "./table/table.component";
// import { TabsComponent } from "./tabs/tabs.component";
import { TabViewModule } from "primeng/tabview";
import { InputTextModule } from 'primeng/inputtext';
// import { InputSearchBoxComponent } from "./input-search-box/input-search-box.component";

// import { TableModule } from 'primeng/table';

// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
  declarations: [
    LayoutComponent,
    FooterComponent,
    QuickSidebarComponent,
    ScrollTopComponent,
    TooltipsComponent,
    // TaskComponent,
    // TableComponent,
    // InputSearchBoxComponent,
    // TabsComponent,
    HrefPreventDefaultDirective,
    UnwrapTagDirective,
  ],
  exports: [
    LayoutComponent,
    FooterComponent,
    // TaskComponent,
    // TableComponent,
    // InputSearchBoxComponent,
    // TabsComponent,
    QuickSidebarComponent,
    ScrollTopComponent,
    TooltipsComponent,
    HrefPreventDefaultDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    HttpClientModule,
    AsideNavSharedModule,
    HeaderNavSharedModule,
    DefaultSharedModule,
    TabViewModule,
    InputTextModule,
    // TableModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [CommonService, TranslateConfigService],
  entryComponents: [
  ],
})
export class LayoutModule { }
